import { put, call } from 'redux-saga/effects';

import { setupTwoFactorAuth } from '@api/auth';
import { history, vsuiteRoutes } from '@routes';
import { toastError, toastSuccess } from '@store/notifications';

export const twoFactorAuthSetupSaga = function* ({
  payload: { phonePrefix, phoneNumber, token, setSubmitting, isSignup },
}) {
  try {
    if (!phonePrefix || !phoneNumber || !token) return;

    yield call(setupTwoFactorAuth, phonePrefix, phoneNumber, token);

    yield put(
      toastSuccess({
        message: {
          defaultMessage: 'OTP sent.',
          id: 'components.2fa-setup-form.response.success',
        },
      })
    );

    if (!isSignup) yield call(history.push, vsuiteRoutes.TWO_FACTOR_AUTH.make());
  } catch (error) {
    yield put(
      toastError({
        message: {
          defaultMessage: '2FA setup request failed.',
          id: 'components.2fa-setup-form.response.failure',
        },
      })
    );

    yield call(setSubmitting, false);
  }
};
